<template>
  <div class="warning card-item">
    <div class="subtitle">
      - 近期虫量
    </div>
    <table border="0" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th style="width: 80px">
            <div class="cell">站点</div>
          </th>
          <th style="width: 64px">
            <div class="cell">昨日</div>
          </th>
          <th style="width: 80px">
            <div class="cell text-left">
              今日
            </div>
          </th>
          <th>
            <div class="cell text-left">
              今日预警
            </div>
          </th>
        </tr>
      </thead>

      <tbody ref="scroller" :style="`height: ${height - 82}px;`">
        <tr v-for="(item, idx) in data" :key="item.id">
          <td style="width: 80px">
            <el-tooltip
              class="item"
              effect="light"
              placement="right"
              :content="item.name"
            >
              <div class="cell" :style="getColor(idx)">
                {{ item.name }}
              </div>
            </el-tooltip>
          </td>
          <td style="width:64px">
            <div class="cell text-left">
              {{ item.last || 0 }}
            </div>
          </td>
          <td style="width: 80px">
            <div class="cell text-left">{{ item.current || 0 }}</div>
          </td>

          <td style="flex: 1;">
            <div class="cell text-left" :class="getMaxStyle(item)">
              {{ getMax(item) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import colors from '@/utlis/colors'

export default {
  props: {
    loading: Boolean,
    height: Number,
    data: Array
  },
  data() {
    return {
      timer: null,
      index: 0
    }
  },
  methods: {
    scrollTo() {
      let el = this.$refs.scroller
      if (!el) return
      if (this.index === 0) {
        el.scrollTo(0, 0)
        clearInterval(this.timer)
        this.index++
        setTimeout(() => {
          this.timer = setInterval(this.scrollTo, 10)
        }, 2000)
      } else {
        let height = this.data.length * 34 - el.offsetHeight
        let y = this.index * 0.2
        if (y > height) {
          clearInterval(this.timer)
          this.index = 0
          setTimeout(() => {
            this.timer = setInterval(this.scrollTo, 10)
          }, 2000)
        } else {
          el.scrollTo(0, y)
          this.index++
        }
      }
    },
    getMax(site) {
      let max = site.insects[0]
      let name = max.name === '褐飞虱' ? '褐飞虱属' : max.name
      return max.current ? `[${name}]: ${max.current}` : '-'
    },
    getMaxStyle(site) {
      let max = site.insects[0]
      return max.current >= 300
        ? 'text-danger'
        : max.current >= 50
        ? 'text-warn'
        : 'text-success'
    },
    getColor(idx) {
      return `color: ${colors[idx % colors.length]}`
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  watch: {
    data(cur, prev) {
      let height = this.data.length * 34 - this.$refs.scroller.offsetHeight
      if (height > 0) {
        this.index = 0
        if (!prev.length) {
          clearInterval(this.timer)
          this.timer = setInterval(this.scrollTo, 10)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warning {
  overflow: hidden;
  height: 100%;
  table {
    padding: 0;
    width: 100%;
    text-align: left;
    thead {
      background-color: #84aaf15e;
      border: none;
    }
    th,
    td {
      padding: 8px 0;
      box-sizing: border-box;
    }
    tbody {
      display: block;
      // overflow-y: hidden;
      overflow-y: hidden;
    }

    tr {
      display: table;
      width: 100%;
      table-layout: fixed;
      text-align: center;
    }
    tbody tr:nth-child(even) td,
    tbody tr:nth-child(even) td {
      background-color: rgba(20, 53, 114, 0.5);
    }

    .cell {
      padding: 0 8px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: left;
    }
    .cell.text-center {
      text-align: center;
    }
  }
}
</style>
